import { ServiceOffering } from "@idw-types/data/reference-data/generic";
import {
    FormattedWorkflowResultsDetailsResponse,
    WorkflowResultsDetailsResponse
} from "@idw-types/data/workflow-results-details";
import { formatServiceOfferingTotals } from "./service-offering-total-formatter";

export const formatWorkflowResultsDetailsResponse = (
    workflowResultsDetails: WorkflowResultsDetailsResponse,
    serviceOfferings: Array<ServiceOffering>
): FormattedWorkflowResultsDetailsResponse => {
    return {
        summary: {
            approvedSessionCount: workflowResultsDetails.summary.approvedSessionCount,
            approvedSessionPercent: workflowResultsDetails.summary.approvedSessionPercent,
            deniedSessionCount: workflowResultsDetails.summary.deniedSessionCount,
            deniedSessionPercent: workflowResultsDetails.summary.deniedSessionPercent,
            serviceOfferingTotals: formatServiceOfferingTotals(workflowResultsDetails.summary.serviceOfferingTotals, serviceOfferings),
            totalSessionCount: workflowResultsDetails.summary.totalSessionCount
        },
        workflowServices: []
    };
};